@if (models) {
  <div class="card mt-5 py-4">
    <div class="row text-center">
      @for (model of models; track model) {
        <div class="col-6">
          <app-profile-picture class="mt-3" [readMode]="true" [profilePictureUrl]="model.profilePictureUrl "></app-profile-picture>
          <h5>{{model.firstName}}</h5>
        </div>
      }
    </div>
  </div>
} @else {
  <div>Loading...</div>
}


